import React from 'react'
import { MenuItemType } from '@utils/types'
import { Download } from '@components/icons'
import { EditableTitle, WLink } from '@components/atoms'
import styles from './DownloadLink.module.sass'

interface Props {
  item?: MenuItemType
  editMode?: boolean
  className?: string
}

const DownloadLink = (props: Props) => {
  const { item = undefined, editMode = undefined, className = '' } = props

  const classNames = `${styles.root} ${editMode ? styles['root--editMode'] : ''} ${className}`
  const getContent = () => (
    <>
      <EditableTitle
        title={item.name}
        variant="span"
        editMode={editMode}
        className={styles.label}
      />
      <span className={styles.icon}>
        <Download />
      </span>
    </>
  )

  return item || editMode ? (
    item.url && !editMode ? (
      <WLink href={item.url} download className={classNames} newPage={true}>
        {getContent()}
      </WLink>
    ) : (
      <div className={classNames}>{getContent()}</div>
    )
  ) : (
    <></>
  )
}

export default DownloadLink
